<template>
    <div>
        <v-row dense class="mt-2">
            <v-col cols="12" sm="4" md="3">
                <v-select v-model="filtro.periodo" :items="periodos" item-text="nome" item-value="id" label="Período" dense outlined/>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete v-model="filtro.responsavelId" :items="responsaveis" item-text="nome" item-value="id" label="Responsável" clearable dense outlined/>
            </v-col>
            <v-col v-if="!doadorId && !oportunidadeId" cols="12" sm="4" md="3">
                <v-autocomplete v-model="filtro.doadorId" :items="doadores" item-text="nome" item-value="id" label="Doador" clearable dense outlined/>
            </v-col>
            <v-col v-if="!oportunidadeId" cols="12" sm="6" md="3">
                <v-autocomplete v-model="filtro.oportunidadeId" :items="oportunidadesFiltradas" item-text="descricao" item-value="id" label="Captação" clearable dense outlined/>
            </v-col>
        </v-row>
        <div class="d-flex justify-end mb-3">
            <v-btn text color="primary" :loading="carregando" @click="Atualizar"><v-icon left>mdi-refresh</v-icon>Atualizar</v-btn>
            <v-btn color="primary" class="ml-2" @click="Abrir()"><v-icon left>mdi-plus</v-icon>Nova atividade</v-btn>
        </div>
        <v-alert v-if="erro" type="error" text>{{ erro }}</v-alert>
        <v-data-table :headers="headers" :items="atividades" :loading="carregando" :sort-by="['dataPrevista', 'horaPrevista', 'id']" :items-per-page="15" no-data-text="Nenhuma atividade encontrada.">
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon small aria-label="Editar atividade" @click="Abrir(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                <v-btn v-if="item.situacao === 'P'" icon small color="success" aria-label="Concluir atividade" :disabled="salvando" @click="Concluir(item)"><v-icon small>mdi-check</v-icon></v-btn>
            </template>
            <template v-slot:[`item.dataPrevista`]="{ item }"><span :class="item.atrasada ? 'error--text font-weight-bold' : ''">{{ Data(item.dataPrevista) }} {{ Hora(item.horaPrevista) }}</span></template>
            <template v-slot:[`item.situacaoNome`]="{ item }"><v-chip small :color="item.atrasada ? 'error' : item.situacao === 'C' ? 'success' : undefined" :outlined="!item.atrasada">{{ item.atrasada ? 'Atrasada' : Situacao(item.situacao) }}</v-chip></template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="850" persistent>
            <v-card>
                <v-card-title class="primary white--text">{{ atividade.id ? 'Editar atividade' : 'Nova atividade' }}</v-card-title>
                <v-card-text class="pt-5">
                    <v-form ref="formAtividade" v-model="valido" lazy-validation>
                        <v-row dense>
                            <v-col v-if="!oportunidadeId" cols="12"><v-autocomplete v-model="atividade.oportunidadeId" :items="oportunidades" item-text="descricao" item-value="id" label="Captação" :rules="obrigatorio" :disabled="atividade.id > 0" dense outlined/></v-col>
                            <v-col cols="12" sm="6"><v-select v-model="atividade.tipo" :items="tipos" item-text="nome" item-value="id" label="Tipo" :rules="obrigatorio" dense outlined/></v-col>
                            <v-col cols="12" sm="6"><v-autocomplete v-model="atividade.responsavelId" :items="responsaveis" item-text="nome" item-value="id" label="Responsável" clearable dense outlined/></v-col>
                            <v-col cols="12"><v-text-field v-model="atividade.descricao" label="Descrição" :rules="obrigatorio" dense outlined/></v-col>
                            <v-col cols="12" sm="4"><v-text-field v-model="atividade.dataPrevista" type="date" label="Data prevista" :rules="obrigatorio" dense outlined/></v-col>
                            <v-col cols="12" sm="4"><v-text-field v-model="atividade.horaPrevista" type="time" label="Hora prevista" clearable dense outlined/></v-col>
                            <v-col cols="12" sm="4"><v-select v-model="atividade.situacao" :items="situacoes" item-text="nome" item-value="id" label="Situação" :rules="obrigatorio" dense outlined/></v-col>
                            <v-col v-if="atividade.dataConclusao" cols="12"><div class="text-caption">Concluída em {{ DataHora(atividade.dataConclusao) }}</div></v-col>
                            <v-col cols="12"><v-textarea v-model="atividade.observacoes" label="Observações" rows="3" dense outlined/></v-col>
                        </v-row>
                    </v-form>
                    <v-alert v-if="erroCadastro" type="error" text>{{ erroCadastro }}</v-alert>
                </v-card-text>
                <v-card-actions><v-spacer/><v-btn text :disabled="salvando" @click="dialog = false">Fechar</v-btn><v-btn color="primary" :loading="salvando" :disabled="!valido" @click="Salvar">Salvar</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import OportunidadeService from '../../../core/services/doacao/OportunidadeService';

export default {
    props: {
        oportunidadeId: { type: Number, default: null },
        doadorId: { type: Number, default: null }
    },
    data: () => ({
        service: new OportunidadeService(),
        atividades: [], oportunidades: [], responsaveis: [],
        carregando: false, salvando: false, dialog: false, valido: true,
        erro: '', erroCadastro: '', requisicao: 0, preparacao: 0,
        filtro: { periodo: 'todas', responsavelId: null, doadorId: null, oportunidadeId: null },
        atividade: {},
        obrigatorio: [v => !!v || 'Campo obrigatório'],
        periodos: [{ id: 'todas', nome: 'Todas' }, { id: 'hoje', nome: 'Hoje' }, { id: 'atrasadas', nome: 'Atrasadas' }, { id: '7dias', nome: 'Próximos 7 dias' }, { id: '30dias', nome: 'Próximos 30 dias' }, { id: 'concluidas', nome: 'Concluídas' }],
        tipos: [{ id: 1, nome: 'Ligação' }, { id: 2, nome: 'WhatsApp' }, { id: 3, nome: 'E-mail' }, { id: 4, nome: 'Reunião' }, { id: 5, nome: 'Visita' }, { id: 6, nome: 'Envio de proposta' }, { id: 7, nome: 'Envio de documentação' }, { id: 8, nome: 'Outros' }],
        situacoes: [{ id: 'P', nome: 'Pendente' }, { id: 'C', nome: 'Concluída' }, { id: 'X', nome: 'Cancelada' }]
    }),
    computed: {
        headers() {
            const result = [{ text: 'Ações', value: 'actions', sortable: false }, { text: 'Descrição', value: 'descricao' }, { text: 'Tipo', value: 'tipoNome' }];
            if (!this.oportunidadeId) result.push({ text: 'Captação', value: 'oportunidadeDescricao' }, { text: 'Doador', value: 'doadorNome' });
            return result.concat([{ text: 'Responsável', value: 'responsavelNome' }, { text: 'Previsão', value: 'dataPrevista' }, { text: 'Situação', value: 'situacaoNome' }]);
        },
        doadores() {
            return this.oportunidades.reduce((lista, item) => {
                if (!lista.some(x => x.id === item.doadorId)) lista.push({ id: item.doadorId, nome: item.doadorNome });
                return lista;
            }, []);
        },
        oportunidadesFiltradas() {
            const id = this.doadorId || this.filtro.doadorId;
            return this.oportunidades.filter(x => !id || x.doadorId === id);
        }
    },
    watch: {
        oportunidadeId() { this.Resetar(); },
        doadorId() { this.Resetar(); },
        'filtro.doadorId'() {
            if (this.filtro.oportunidadeId && !this.oportunidadesFiltradas.some(x => x.id === this.filtro.oportunidadeId)) this.filtro.oportunidadeId = null;
        }
    },
    created() { this.Preparar(); },
    beforeDestroy() { this.requisicao++; this.preparacao++; },
    methods: {
        async Preparar() {
            const preparacao = ++this.preparacao;
            this.erro = '';
            try {
                const respostas = await Promise.all([this.service.Responsaveis(), this.oportunidadeId ? Promise.resolve({ data: { oportunidades: [] } }) : this.service.Painel(this.doadorId ? { doadorId: this.doadorId } : {})]);
                if (preparacao !== this.preparacao) return;
                this.responsaveis = respostas[0].data || [];
                this.oportunidades = respostas[1].data.oportunidades || [];
            } catch (err) { if (preparacao === this.preparacao) this.erro = this.Mensagem(err); }
            if (preparacao === this.preparacao) await this.Atualizar();
        },
        Resetar() {
            this.requisicao++;
            this.preparacao++;
            this.atividades = [];
            this.oportunidades = [];
            this.dialog = false;
            this.filtro = { periodo: 'todas', responsavelId: null, doadorId: null, oportunidadeId: null };
            this.Preparar();
        },
        async Atualizar() {
            const requisicao = ++this.requisicao;
            this.carregando = true;
            this.erro = '';
            try {
                const res = await this.service.ListarAtividades(Object.assign({}, this.filtro, { oportunidadeId: this.oportunidadeId || this.filtro.oportunidadeId, doadorId: this.doadorId || this.filtro.doadorId }));
                if (requisicao === this.requisicao) this.atividades = res.data || [];
            } catch (err) { if (requisicao === this.requisicao) this.erro = this.Mensagem(err); }
            finally { if (requisicao === this.requisicao) this.carregando = false; }
        },
        Abrir(item) {
            this.erroCadastro = '';
            this.atividade = item ? {
                id: item.id, empresaId: item.empresaId, oportunidadeId: item.oportunidadeId, tipo: item.tipo,
                descricao: item.descricao, responsavelId: item.responsavelId, dataPrevista: (item.dataPrevista || '').slice(0, 10),
                horaPrevista: this.Hora(item.horaPrevista) || null, situacao: item.situacao, dataConclusao: item.dataConclusao,
                observacoes: item.observacoes, versao: item.versao
            } : { id: 0, oportunidadeId: this.oportunidadeId || this.filtro.oportunidadeId || null, tipo: null, descricao: '', responsavelId: null, dataPrevista: '', horaPrevista: null, situacao: null, observacoes: '', versao: 0 };
            this.dialog = true;
            this.$nextTick(() => { if (this.$refs.formAtividade) this.$refs.formAtividade.resetValidation(); });
        },
        async Salvar() {
            if (this.salvando || !this.$refs.formAtividade.validate()) return;
            this.salvando = true;
            this.erroCadastro = '';
            try {
                await this.service.SalvarAtividade(Object.assign({}, this.atividade, { horaPrevista: this.atividade.horaPrevista || null }));
                this.dialog = false;
                await this.Atualizar();
                this.$emit('atualizado');
            } catch (err) { this.erroCadastro = this.Mensagem(err); }
            finally { this.salvando = false; }
        },
        async Concluir(item) {
            if (this.salvando) return;
            this.salvando = true;
            this.erro = '';
            try {
                await this.service.SalvarAtividade({ id: item.id, empresaId: item.empresaId, oportunidadeId: item.oportunidadeId, tipo: item.tipo, descricao: item.descricao, responsavelId: item.responsavelId, dataPrevista: item.dataPrevista, horaPrevista: this.Hora(item.horaPrevista) || null, situacao: 'C', dataConclusao: item.dataConclusao, observacoes: item.observacoes, versao: item.versao });
                await this.Atualizar();
                this.$emit('atualizado');
            } catch (err) { this.erro = this.Mensagem(err); }
            finally { this.salvando = false; }
        },
        Situacao(valor) { const item = this.situacoes.find(x => x.id === valor); return item ? item.nome : valor; },
        Hora(valor) { return valor ? String(valor).slice(0, 5) : ''; },
        Data(valor) { const partes = (valor || '').slice(0, 10).split('-'); return partes.length === 3 ? partes.reverse().join('/') : ''; },
        DataHora(valor) { return valor ? new Date(valor).toLocaleString('pt-BR') : ''; },
        Mensagem(err) { const data = err.response && err.response.data; return typeof data === 'string' ? data : (data && (data.detail || data.title)) || 'Não foi possível concluir a operação.'; }
    }
};
</script>
